import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

class Column extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'column',
                marginLeft: 80,
                marginBottom: 200,
                width: 980,
                height: 600,
            },
            xAxis: {
                labels: {
                    enabled: true,
                    overflow: 'justify',
                    align: 'right',
                    rotation: -45,
                    style: {
                        wordWrap: 'break-word',
                        width: 200,
                        textAlign: 'right',
                        color: 'black',
                        fontSize: '12pt'
                    }
                },
            },
            yAxis: {
                labels: {
                    enabled: true,
                    style: {
                        fontSize: '10pt'
                    }
                },
                min: 0,
                max: 5,
                tickInterval: 1,
                gridLineColor: '#C8C8C8',
                title: {
                    text: null,
                    style: {
                        fontSize: '12pt'
                    }
                }
            },
            plotOptions: {
                column: {
                    maxPointWidth: 50, // Bar width
                    colorByPoint: true,
                    dataLabels: {
                        enabled: true,
                        inside: true,
                        align: 'center',
                        verticalAlign: 'middle',
                        style: {
                            color: 'white',
                            textOutline: 'none'
                        }
                    }
                },
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    registerPlugin(Column)
}